import { Injectable, OnDestroy } from '@angular/core';
import { UserState, UserType } from '../store/user.state';
import { Subject, takeUntil } from 'rxjs';
import { UserLocationState } from '../store/user-location.state';
import { environment } from '../../environments/environment';
import { Capacitor } from '@capacitor/core';
import OneSignal from 'onesignal-cordova-plugin';

@Injectable({ providedIn: 'root' })
export class OneSignalService implements OnDestroy {
  constructor(
    private userState: UserState,
    private userLocationState: UserLocationState,
  ) {}

  private destroyed$ = new Subject<void>();

  initialize(): void {
    if (Capacitor.isNativePlatform()) {
      // Enable verbose logging for debugging (remove in production)
      OneSignal.Debug.setLogLevel(6);
      // Initialize with your OneSignal App ID
      OneSignal.initialize(environment.oneSignalAppId);

      // Use this method to prompt for push notifications.
      // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
      void OneSignal.Notifications.requestPermission(false).then((accepted: boolean) => {
        console.log('User accepted notifications: ' + accepted);
      });

      // Identify guest or user on App Start
      this.userState.user$.pipe(takeUntil(this.destroyed$)).subscribe(user => {
        if (user.userType !== UserType.GUEST) {
          OneSignal.User.addTag('user_type', 'user');
        } else {
          OneSignal.User.addTag('user_type', 'guest');
          OneSignal.User.addTag('guest_id', user.id);
        }
      });
    }
  }

  login(id: string): void {
    OneSignal.login(id);
    OneSignal.User.addTag('user_type', 'user');
  }

  logout(): void {
    OneSignal.logout();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
